// removed by extract-text-webpack-plugin
module.exports = {"Outer":"_22CC9","Inner":"_N--Pw"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Flight/Tuple/TupleInner/FlightInfo/FlightInfoContainer/FlightInfoContainer.scss
// module id = 514
// module chunks = 0